<!-- Bits -->
<div class="bitting-box" *ngFor="let bit of kba.bits; let index = index">
    <div class="bitting" matTooltip="{{message(bit)}}" [ngClass]="{
      'warning-start': (bit.hasWarning && kba.bits[index - 1] && !kba.bits[index - 1].hasWarning) || ( bit.hasWarning && !kba.bits[index - 1] ),
      'warning-middle': bit.hasWarning && kba.bits[index - 1] && kba.bits[index - 1].hasWarning,
      'warning-end': (bit.hasWarning && kba.bits[index + 1] && !kba.bits[index + 1].hasWarning) || (bit.hasWarning && !kba.bits[index + 1]),
      'warning': bit.hasWarning && (
      (kba.bits[index - 1] && !kba.bits[index - 1].hasWarning) &&
      (kba.bits[index + 1] && !kba.bits[index + 1].hasWarning) ||
      (!kba.bits[index - 1] && !kba.bits[index + 1].hasWarning || !kba.bits[index + 1] && !kba.bits[index - 1].hasWarning)
      ),
      'error-start': (bit.hasError && kba.bits[index - 1] && !kba.bits[index - 1].hasError) || ( bit.hasError && !kba.bits[index - 1] ),
      'error-end': (bit.hasError && kba.bits[index + 1] &&
                    ( !kba.bits[index + 1].hasWarning || !kba.bits[index].hasWarning  ) &&
                    !kba.bits[index + 1].hasError) ||
                    (bit.hasError && !kba.bits[index + 1]),
      'error-middle': (bit.hasError && kba.bits[index - 1] && kba.bits[index - 1].hasError) ||
                      (bit.hasError && kba.bits[index - 1] && kba.bits[index - 1].hasWarning && kba.bits[index].hasWarning) ||
                      (bit.hasError && kba.bits[index - 1] && kba.bits[index].hasWarning && kba.bits[index + 1].hasWarning && kba.bits[index].hasWarning),
      'error': bit.hasError && (
      (kba.bits[index - 1] && !kba.bits[index - 1].hasError) &&
      (kba.bits[index + 1] && !kba.bits[index + 1].hasError) ||
      (!kba.bits[index - 1] && !kba.bits[index + 1].hasError || !kba.bits[index + 1] && !kba.bits[index - 1].hasError)
      ),
      'filtered': !kba.show,
      'unfiltered': kba.show,
      'in-filter': bit.inFilter,
      'out-of-filter': !bit.inFilter
    }">
      <div>{{bit.value}}</div>
    </div>
</div>